import { combineReducers } from 'redux';
import dashboard from './dashboard.reducer';
import cpuAvg from './cpuAvg.reducer';
import {selectedCluster, allCluster} from './selectCluster.reducer';
import dashboardMetrics from './dashboardMetrics.reducer';
import userPreferences from './userPreferences.reducer';

const reducer = combineReducers({
	dashboard,
	cpuAvg,
	selectedCluster,
	allCluster,
	dashboardMetrics,
	userPreferences,
});

export default reducer;
